import i18n from "./locale";
import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import { initTheme } from '@atom/b2c-tokens';
import '@atom/b2c-tokens/dist/variables_375_rem.css';
import { Tabs, Tab, Swipe, SwipeItem } from '@atom/atom-ui';
import { TaLog } from '@/common'

initTheme();

// 全局样式
import './assets/styles/global.less';
//兼容处理
import './utils/rem';
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.prototype.$Talog = TaLog

window.$projectName = 'ifinDHome';
Vue.config.productionTip = false;
const app = new Vue({
  i18n: i18n,
  router,
  render: h => h(App)
}).$mount('#app');